import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import useTable from '../components/useTable';
import { TableBody, TableRow, TableCell } from '@mui/material';
import { Dimmer } from '../components/spinner';
import { formatMoneda } from '../util/varios';
import axios from "axios";

const CatalogoAllCuentasContables = props => {
    let op = require('../modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'))

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [selectedCuenta, setSelectedCuenta] = useState(null);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CODIGO', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'DESCRIPCION', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'ID', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        const codigoFormateado = formatearCodigoCuenta(x.codigocuenta);
                        if (codigoFormateado.includes(target.value) ||
                            x.codigocuenta.includes(target.value) ||
                            x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                        return null;
                    });
                }
            }
        })
    }

    const formatearCodigoCuenta = (codigo) => {
        if (!codigo) return '';
        return codigo.substring(0, 2) + '-' + 
               codigo.substring(2, 5) + '-' + 
               codigo.substring(5, 7) + '-' + 
               codigo.substring(7, 9) + '-' + 
               codigo.substring(9, 12);
    }

    const seleccionarRegistros = () => {
        let campos = "c.*,p.descripcion,p.cargable "
        let nomtab = "cuentacontable c,plancuenta p";
        let condi = `c.idplancuenta = p.idplancuenta AND p.idefiscal = ${idefiscal}`;
        let orden = "codigocuenta";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.length > 0) {
                    setRecords(response.data);
                } else {
                    setRecords([]);
                }
            }
        }).catch(function (error) {
            setMensaje({ 
                mostrar: true, 
                titulo: 'Error', 
                texto: error.response?.data?.message || 'Error al cargar las cuentas contables', 
                icono: 'error' 
            });
        }).finally(() => {
            setActivate(false);
        })
    }

    const blanquear = () => {
        setSelectedCuenta(null);
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }

    const cancelar = () => {
        blanquear();
        if (props.onHideCancelar) {
            props.onHideCancelar();
        }
    }

    const seleccionarCuenta = () => {
        if (selectedCuenta) {
            if (props.onHideAceptaCatalogo) {
                props.onHideAceptaCatalogo(selectedCuenta);
            }
            cancelar();
        } else {
            setMensaje({
                mostrar: true,
                titulo: 'Información',
                texto: 'Debe seleccionar una cuenta contable',
                icono: 'informacion'
            });
        }
    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setSelectedCuenta(item);
    };

    // Formatear el código para mostrar en la tabla
    const getCodigoFormateado = (codigo) => {
        if (!codigo) return '';
        return codigo.substring(0, 2) + '-' + 
               codigo.substring(2, 5) + '-' + 
               codigo.substring(5, 7) + '-' + 
               codigo.substring(7, 9) + '-' + 
               codigo.substring(9, 12);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light"><h3>Seleccionar Cuenta Contable</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} />
                
                <div className="col-md-12 m-0">
                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input 
                            type='text'
                            placeholder="Buscar por código o descripción..."
                            onChange={handleSearch} 
                            className="form-control rounded-pill search-input" 
                        />
                    </div>
                </div>
                
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer>
                        <TblHead />
                        <tbody>
                            {recordsAfterPagingAndSorting().map((item, index) => (
                                <tr 
                                    key={index} 
                                    style={{ 
                                        padding: "0", 
                                        cursor: 'pointer', 
                                        background: selectedCuenta?.idplancuenta === item.idplancuenta ? "lightskyblue" : "white" 
                                    }} 
                                    onClick={seleccionarFila(item)}
                                >
                                    <td className='py-2 text-center'>{getCodigoFormateado(item.codigocuenta)}</td>
                                    <td className='py-2 text-start'>{item.descripcion}</td>
                                    <td className='py-2 text-start'>{item.idplancuenta}</td>
                                </tr>
                            ))}
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={seleccionarCuenta}>
                    <i className="fas fa-check-circle"> Aceptar</i>
                </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill">
                    <i className="fas fa-window-close"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoAllCuentasContables;